export const CONTACT_EMAIL = 'modmedianow@gmail.com';

export const SHIPPING_NOTICE = 'Free Shipping on eBay, and Free Delivery on Local Orders in Lane County, Oregon!';

export const LISTING_TYPES = {
  EBAY: 'ebay',
  LOCAL: 'local',
  SHOWCASE: 'showcase',
};

export const EMPTY_GAMING_CARD = {
  title: '',
  description: '',
  listing_type: LISTING_TYPES.LOCAL,
  external_link: '',
  sort_order: 0,
  image: null,
};

export const cardFromRow = (row) => ({
  title: row.title || '',
  description: row.description || '',
  listing_type: row.listing_type || LISTING_TYPES.LOCAL,
  external_link: row.external_link || '',
  sort_order: row.sort_order || 0,
  image: null,
});
